import React, { useEffect, useState } from 'react';
import useMissionsTutorial from 'shared/hooks/useMissionsTutorial';
import { MissionTutorialStepsKeys, tutorialPointerEvents, TUTORIAL_NAME } from 'shared/utils/tutorial';
import { Container, Layer, SkipButton, SkipButtonContainer, tutorialStepLayout } from './styledComponents';
import { ASSET_KEY, assetSource } from 'shared/utils/assetSource';
import useUpdateHeight from '../../hooks/useUpdateHeight';

const MissionsTutorialLayer = props => {
  const { tutorial, missionsAssets } = props;
  const { activeTutorial, tutorialStep, tutorialName } = tutorial;
  const { skipTutorial, handleFeedForwardTutorial } = useMissionsTutorial(props);
  const { windowHeight } = useUpdateHeight();
  const {
    IMAGE,
    TOOLTIP = null,
    TOP = null,
    BOTTOM = null,
    RIGHT = null,
    LEFT = null,
  } = tutorialStepLayout(missionsAssets)[tutorialStep];

  const [renderImage, setImageRender] = useState(IMAGE);

  useEffect(() => {
    setImageRender(IMAGE);
  }, [IMAGE]);

  return (
    <Container
      pointerEvents={tutorialPointerEvents(tutorialStep === MissionTutorialStepsKeys.CHECK_OUT)}
      $activeTutorial={activeTutorial && tutorialName === TUTORIAL_NAME.MISSIONS_TUTORIAL}
    >
      {tutorialStep !== MissionTutorialStepsKeys.COMPLETED && (
        <SkipButtonContainer $windowHeight={windowHeight} onClick={skipTutorial}>
          <SkipButton src={assetSource(ASSET_KEY.SKIP_BUTTON)} />
        </SkipButtonContainer>
      )}

      <Layer
        pointerEvents={tutorialPointerEvents(tutorialStep === MissionTutorialStepsKeys.CHECK_OUT)}
        onClick={handleFeedForwardTutorial}
      >
        {IMAGE === renderImage && <TOOLTIP $windowHeight={windowHeight} src={IMAGE} />}
        {TOP && <TOP $windowHeight={windowHeight} />}
        {BOTTOM && <BOTTOM $windowHeight={windowHeight} />}
        {RIGHT && <RIGHT $windowHeight={windowHeight} />}
        {LEFT && <LEFT $windowHeight={windowHeight} />}
      </Layer>
    </Container>
  );
};

export default MissionsTutorialLayer;

